module.exports = __webpack_public_path__ + "static/media/Onboarding-Desktop-With-Typography-v4.png";